import { readPageData } from "./page";
import { ref } from "vue";
export var ThemeType;
(function (ThemeType) {
    ThemeType["Zumba"] = "zumba";
    ThemeType["Strong"] = "strong";
})(ThemeType || (ThemeType = {}));
export const theme = ref(Object.values(ThemeType).includes(readPageData('theme')) ? readPageData('theme') : ThemeType.Zumba);
export const overrideTheme = (newTheme) => theme.value = newTheme;
